// extracted by mini-css-extract-plugin
export default {"MfeHeader":"MfeHeaderLight__MfeHeader___D2LfP","MfeHeaderTitle":"MfeHeaderLight__MfeHeaderTitle___TXh2S"};